import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ContestComponent} from './contest.component';
import {ContestDetailComponent} from './contest-detail.component';
import {CurrentContestSummaryComponent} from './current-contest-summary.component';

const routes: Routes = [
    { path: '', component: CurrentContestSummaryComponent},
    { path: 'contests',  component: ContestComponent },
    { path: 'contest/:id', component: ContestDetailComponent }
];
@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/william/Documents/gitlab/stovokor/src/app/app-routing.module.ts